/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Cart App Tier
 * This is to provide all the cart related operations at cart app tier.
 *
 * The version of the OpenAPI document: v2
 * Contact: Pankaj.Gautam@Amway.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Exceptions = {
    RationingService: 'RATIONING SERVICE',
    PromotionService: 'PROMOTION SERVICE',
    FulfillmentService: 'FULFILLMENT SERVICE',
    ProfileService: 'PROFILE SERVICE',
    AccountService: 'ACCOUNT SERVICE',
    AccountSearchService: 'ACCOUNT SEARCH SERVICE',
    ProductService: 'PRODUCT SERVICE',
    ProductValidationService: 'PRODUCT VALIDATION SERVICE',
    CartDataService: 'CART DATA SERVICE',
    AccountType: 'ACCOUNT TYPE',
    SpecifiedUser: 'SPECIFIED USER',
    Anonymous: 'ANONYMOUS',
    NonAbo: 'NON ABO',
    AwardLevel: 'AWARD LEVEL',
    LosService: 'LOS SERVICE',
    AddToCart: 'ADD TO CART',
    PickUp: 'PICK UP',
    Delivery: 'DELIVERY',
    LengthOfAffiliation: 'LENGTH OF AFFILIATION',
    InvalidProduct: 'INVALID PRODUCT',
    SopElementExpired: 'SOP ELEMENT EXPIRED',
    InvalidCoupons: 'INVALID COUPONS',
    ProductQtyLimitExceed: 'PRODUCT_QTY_LIMIT_EXCEED',
    ProductQtyPartiallyAdded: 'PRODUCT_QTY_PARTIALLY_ADDED',
    RegistrationService: 'REGISTRATION SERVICE',
    RenewalBlocked: 'RENEWAL BLOCKED',
    BlockAndPrivilegeService: 'BLOCK AND PRIVILEGE SERVICE',
    Restricted: 'RESTRICTED',
    CartLevelPromotion: 'CART LEVEL PROMOTION',
    EntityVersionConflict: 'ENTITY_VERSION_CONFLICT',
    CartNotFound: 'CART_NOT_FOUND',
    SubCartNotFound: 'SUB_CART_NOT_FOUND',
    CartEntryNotFound: 'CART_ENTRY_NOT_FOUND',
    RedeemAmpointInsufficient: 'REDEEM_AMPOINT_INSUFFICIENT',
    RedeemAmpointFailed: 'REDEEM_AMPOINT_FAILED',
    RedeemAmpointMaxTotalQuotaExceed: 'REDEEM_AMPOINT_MAX_TOTAL_QUOTA_EXCEED',
    RedeemAmpointMaxPerAccountQuotaExceed: 'REDEEM_AMPOINT_MAX_PER_ACCOUNT_QUOTA_EXCEED',
    CartBizService: 'CART_BIZ_SERVICE',
    RationingLimitExceed: 'RATIONING_LIMIT_EXCEED',
    ProductOutOfStock: 'PRODUCT_OUT_OF_STOCK',
    FreeProductOutOfStock: 'FREE_PRODUCT_OUT_OF_STOCK',
    TaxDataService: 'TAX_DATA_SERVICE'
} as const;
export type Exceptions = typeof Exceptions[keyof typeof Exceptions];


export function ExceptionsFromJSON(json: any): Exceptions {
    return ExceptionsFromJSONTyped(json, false);
}

export function ExceptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Exceptions {
    return json as Exceptions;
}

export function ExceptionsToJSON(value?: Exceptions | null): any {
    return value as any;
}

